import { useEffect, useState } from "react";
import api from "@/lib/api";
import { eur, fmtDate, Loading, EmptyState, PaymentBadge } from "@/components/common";

const SUB_LABELS = { attiva: "Attivo", in_attesa_attivazione: "In attesa attivazione", sospesa: "Sospeso", annullata: "Annullato" };

export default function AdminIscrizioni() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/admin/iscrizioni").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  if (!rows) return <Loading />;

  return (
    <div data-testid="admin-iscrizioni">
      <h2 className="font-serif text-2xl text-navy mb-1">Nuove iscrizioni</h2>
      <p className="text-sm text-muted-soft mb-6">
        Chi si è registrato, il comune di riferimento, il professionista assegnato automaticamente e lo stato del pagamento.
      </p>
      {rows.length === 0 ? (
        <EmptyState title="Nessuna iscrizione" />
      ) : (
        <>
          {/* Mobile: schede compatte, nessuna tabella tagliata */}
          <div className="space-y-3 lg:hidden">
            {rows.map((r) => (
              <div key={r.customer_id} className="card-soft p-4 space-y-2" data-testid={`iscrizione-${r.customer_id}`}>
                <div className="flex justify-between items-start gap-3">
                  <div className="min-w-0">
                    <p className="text-navy font-medium truncate">{r.customer_name}</p>
                    <p className="text-xs text-muted-soft truncate">{r.email}{r.phone ? ` · ${r.phone}` : ""}</p>
                  </div>
                  {r.payment_status && <PaymentBadge status={r.payment_status} method={r.method} />}
                </div>
                <div className="text-sm text-body space-y-0.5">
                  <p>{r.comune || "—"}{r.cemetery ? ` · ${r.cemetery}` : ""}</p>
                  <p className="text-xs text-muted-soft">Professionista: {r.professional_name || "Da assegnare"}</p>
                  <p className="text-xs">
                    {r.servizio || "—"}{r.amount != null ? ` · ${eur(r.amount)}` : ""}{r.method ? ` · ` : ""}<span className="capitalize">{r.method || ""}</span>
                    {r.subscription_status ? ` · Abb.: ${SUB_LABELS[r.subscription_status] || r.subscription_status}` : ""}
                  </p>
                  <p className="text-xs text-muted-soft">Registrato il {fmtDate(r.registered_at)}</p>
                </div>
              </div>
            ))}
          </div>
          {/* Desktop: tabella completa */}
          <div className="card-soft overflow-x-auto hidden lg:block">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-muted-soft border-b border-[#e2e8f0]">
                  <th className="p-4">Cliente</th>
                  <th className="p-4">Comune</th>
                  <th className="p-4">Professionista</th>
                  <th className="p-4">Servizio</th>
                  <th className="p-4">Importo</th>
                  <th className="p-4">Metodo</th>
                  <th className="p-4">Pagamento</th>
                  <th className="p-4">Abbonamento</th>
                  <th className="p-4">Registrato il</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.customer_id} className="border-b border-[#f1f5f9] last:border-0" data-testid={`iscrizione-row-${r.customer_id}`}>
                    <td className="p-4">
                      <p className="text-navy font-medium">{r.customer_name}</p>
                      <p className="text-xs text-muted-soft">{r.email}{r.phone ? ` · ${r.phone}` : ""}</p>
                    </td>
                    <td className="p-4">
                      <p className="text-navy">{r.comune || "—"}</p>
                      {r.cemetery && <p className="text-xs text-muted-soft">{r.cemetery}</p>}
                    </td>
                    <td className="p-4">{r.professional_name || <span className="text-muted-soft">Da assegnare</span>}</td>
                    <td className="p-4">{r.servizio || "—"}</td>
                    <td className="p-4 font-semibold text-navy whitespace-nowrap">{r.amount != null ? eur(r.amount) : "—"}</td>
                    <td className="p-4 capitalize">{r.method || "—"}</td>
                    <td className="p-4">{r.payment_status ? <PaymentBadge status={r.payment_status} method={r.method} /> : "—"}</td>
                    <td className="p-4">{r.subscription_status ? SUB_LABELS[r.subscription_status] || r.subscription_status : "—"}</td>
                    <td className="p-4 whitespace-nowrap">{fmtDate(r.registered_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
